import { Cue, sound } from './audio';

const BUZZ: Partial<Record<Cue, number | number[]>> = {
    start: 15,
    poke: 10,
    explode: [70, 30, 140],
    bounce: 12,
    land: 40,
    launch: [20, 20, 20, 20, 60],
    fanfare: [20, 40, 20, 40, 60],
    chime: 25,
};

/** One cue = a sound plus a short haptic buzz where the device has one. */
export const playCue = (cue: Cue, pitch = 1): void => {
    sound.play(cue, pitch);
    const pattern = BUZZ[cue];
    if (
        pattern !== undefined &&
        !sound.muted &&
        typeof navigator.vibrate === 'function'
    ) {
        try {
            navigator.vibrate(pattern);
        } catch {
            // Not allowed before a tap; harmless.
        }
    }
};
